import { ACTOR_JUSTIFICATION_MIN_LENGTH } from '@/userManagement/domain/constants/approvalPermissionPolicies';

/** Rejects actor review notes that are present but shorter than the BE minimum. */
export function requireMinLengthReviewNotes(value: string | undefined, fieldLabel: string): string {
  const trimmed = value?.trim() ?? '';
  if (trimmed.length < ACTOR_JUSTIFICATION_MIN_LENGTH) {
    throw new Error(`${fieldLabel} must be at least ${ACTOR_JUSTIFICATION_MIN_LENGTH} characters.`);
  }
  return trimmed;
}

/**
 * Resolves apply justification for POST /approval-requests/{id}/apply.
 * Preserves non-empty actor text; rejects text that is too short; uses fallback only when omitted.
 */
export function resolveApplyJustification(value: string | undefined, fallbackWhenEmpty: string): string {
  const trimmed = value?.trim() ?? '';
  if (trimmed.length >= ACTOR_JUSTIFICATION_MIN_LENGTH) {
    return trimmed;
  }
  if (trimmed.length > 0) {
    throw new Error(`Justification must be at least ${ACTOR_JUSTIFICATION_MIN_LENGTH} characters.`);
  }

  const fallback = fallbackWhenEmpty.trim();
  if (fallback.length >= ACTOR_JUSTIFICATION_MIN_LENGTH) {
    return fallback;
  }
  return `${fallback}${' '.repeat(ACTOR_JUSTIFICATION_MIN_LENGTH - fallback.length)}`.slice(0, ACTOR_JUSTIFICATION_MIN_LENGTH);
}
